import { EClickPosition } from 'shared/constant';
import { useSetAtom } from 'jotai';
import { $CTAModal } from '~/components/cta-modal';
import { SyntheticEvent, useCallback } from 'react';
import { sendClickEvent } from '~/utils/event';

interface IUseCTAByModalCallbackProps<P> {
  variant: 'primary' | 'v2';
  clickPosition: (params: P) => EClickPosition;
  clickId?: (params: P) => string;
  onConfirm: (params: P) => void;
  onCancel?: (params: P) => void;
}

type TCTAByModalCallback<P> = (params: P) => (e?: SyntheticEvent) => void;

export const useCTAByModalCallback = <P>(props: IUseCTAByModalCallbackProps<P>): TCTAByModalCallback<P> => {
  const { variant, clickPosition, clickId, onCancel, onConfirm } = props;

  const setCTAModal = useSetAtom($CTAModal);

  return useCallback(
    (params: P) => (e?: SyntheticEvent) => {
      // 1. prevent default event behaviour
      e?.preventDefault();

      // 2. click position
      sendClickEvent({
        clickPosition: clickPosition(params),
        clickId: clickId?.(params),
      });

      // 3. show cta model
      setCTAModal({
        variant,
        clickPosition: clickPosition(params),
        clickId: clickId?.(params),
        onConfirm: () => onConfirm(params),
        onCancel: () => onCancel?.(params),
      });
    },
    [clickPosition, clickId, onConfirm, onCancel, setCTAModal],
  );
};
